import { Component } from "@angular/core";

@Component({
	templateUrl: "./key-form.component.html",
	standalone: false,
})
export class KeyFormComponent {}
